export const VAULTX_ICON_SRC = "/VAULTX.png";

const VAULTX_SUBTITLES = {
  vaultx_loan_borrow: "Loan Borrow",
  vaultx_collateral_deposit: "Collateral Deposit",
  vaultx_collateral_return: "Collateral Return",
  vaultx_loan_principal_repayment: "Principal Repayment",
  vaultx_loan_repayment_fee: "Repayment Fee",
  vaultx_loan_repayment_refund: "Refund",
  vaultx_auction_bid_deposit: "Auction Bid",
  vaultx_auction_bid_refund: "Auction Bid Refund",
  vaultx_protocol_outflow_review: "Protocol Outflow Review",
  vaultx_nft_return_review: "NFT Return Review",
};

export function isVaultXClass(classification) {
  return String(classification || "")
    .trim()
    .toLowerCase()
    .startsWith("vaultx_");
}

export function getVaultXDisplay(classification) {
  const cls = String(classification || "")
    .trim()
    .toLowerCase();
  const subtitle = VAULTX_SUBTITLES[cls];
  if (!subtitle) return null;

  return {
    title: "VaultX",
    subtitle,
  };
}
